import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { PlaybookShort } from "../../playbook/model/Playbook";

export const useGetSystemPlaybooks = () => {
  const {
    data: systemPlaybooks,
    call,
    isLoading,
    isFailed,
    setData: setPlaybooks,
  } = useApiPrivateRequest<PlaybookShort[]>((response) =>
    response.map((playbook: any) => new PlaybookShort(playbook)),
  );

  const getSystemPlaybooks = async () => {
    await call(`/admin/playbooks`, "GET");
  };

  return {
    systemPlaybooks,
    getSystemPlaybooks,
    isLoading,
    isFailed,
    setPlaybooks,
  };
};
